import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { profileIconImages } from "@/lib/constants";
import styles from "@/styles/Profile.module.scss";
import Image from "next/image";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconLock = function IconLock(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.75,5.833V3.5a3.5,3.5,0,0,0-7,0V5.833H3V14H13.5V5.833ZM8.833,10.338v1.328H7.667V10.338a1.167,1.167,0,1,1,1.167,0ZM5.917,5.833V3.5a2.333,2.333,0,1,1,4.667,0V5.833Z",
      transform: "translate(-3)",
      fill: "#252525"
    })
  }));
};

IconLock.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10.5",
  height: "14",
  viewBox: "0 0 10.5 14"
};

function ProfileIconImage(_ref) {
  var icon = _ref.icon,
      displayName = _ref.displayName,
      ownerProfile = _ref.ownerProfile,
      needPasscode = _ref.needPasscode,
      onClick = _ref.onClick;
  var path = profileIconImages[icon] || profileIconImages[1];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.icon,
    onClick: onClick,
    children: [ownerProfile && !needPasscode && /*#__PURE__*/_jsx("span", {
      className: styles.ownerLabel,
      children: "\u30AA\u30FC\u30CA\u30FC"
    }), !ownerProfile && needPasscode && /*#__PURE__*/_jsx("span", {
      className: styles.keyLabel,
      children: /*#__PURE__*/_jsx("span", {
        className: styles.lock,
        children: /*#__PURE__*/_jsx(IconLock, {})
      })
    }), ownerProfile && needPasscode && /*#__PURE__*/_jsxs("span", {
      className: styles.ownerAndKeyLabel,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.owner,
        children: "\u30AA\u30FC\u30CA\u30FC"
      }), /*#__PURE__*/_jsx("span", {
        className: styles.lock,
        children: /*#__PURE__*/_jsx(IconLock, {})
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.image,
      children: /*#__PURE__*/_jsx(Image, {
        src: path,
        alt: displayName,
        layout: "fill"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.name,
      children: displayName
    })]
  });
}

export default /*#__PURE__*/memo(ProfileIconImage);